// Global Cart Notification helper if not defined
if (!window.showCartNotification) {
  // Inject style block if needed
  if (!document.getElementById('sds-cart-notification-styles')) {
    const style = document.createElement('style');
    style.id = 'sds-cart-notification-styles';
    style.textContent = `
      .sds-cart-toast {
        position: fixed;
        bottom: 24px;
        right: 24px;
        background: #0a0a0c;
        border: 1px solid #1f1f22;
        border-left: 4px solid #c0f20c;
        color: #fff;
        padding: 16px 20px;
        border-radius: 8px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.5);
        z-index: 10000;
        display: flex;
        align-items: center;
        gap: 16px;
        transform: translateY(150%);
        transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        max-width: 400px;
        font-family: inherit;
      }
      .sds-cart-toast.active {
        transform: translateY(0);
      }
      .sds-toast-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
        text-align: left;
      }
      .sds-toast-title {
        font-family: 'Sakana-Regular', sans-serif !important;
        font-style: italic !important;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #c0f20c;
      }
      .sds-toast-desc {
        font-size: 12px;
        color: #a3a3a3;
      }
      .sds-toast-actions {
        display: flex;
        gap: 10px;
        margin-top: 8px;
      }
      .sds-toast-btn {
        background: #c0f20c;
        color: #000;
        border: none;
        padding: 6px 12px;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        border-radius: 4px;
        cursor: pointer;
        text-decoration: none;
        display: inline-block;
      }
      .sds-toast-btn-secondary {
        background: transparent;
        color: #fff;
        border: 1px solid #1f1f22;
      }
      .sds-toast-close {
        color: #737373;
        background: transparent;
        border: none;
        font-size: 16px;
        cursor: pointer;
        align-self: flex-start;
      }
    `;
    document.head.appendChild(style);
  }

  window.showCartNotification = function(title, message) {
    const existing = document.querySelector('.sds-cart-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'sds-cart-toast';
    toast.innerHTML = `
      <div class="sds-toast-content">
        <span class="sds-toast-title">${title}</span>
        <span class="sds-toast-desc">${message}</span>
        <div class="sds-toast-actions">
          <a href="/cart" class="sds-toast-btn">View Cart</a>
          <button type="button" class="sds-toast-btn sds-toast-btn-secondary" onclick="this.closest('.sds-cart-toast').classList.remove('active')">Continue</button>
        </div>
      </div>
      <button type="button" class="sds-toast-close" onclick="this.closest('.sds-cart-toast').classList.remove('active')">&times;</button>
    `;
    document.body.appendChild(toast);
    
    setTimeout(() => toast.classList.add('active'), 100);

    setTimeout(() => {
      toast.classList.remove('active');
      setTimeout(() => toast.remove(), 400);
    }, 5000);
  };
}

if (!window.updateHeaderCartCount) {
  window.updateHeaderCartCount = function() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartLink = document.getElementById('cart-icon-bubble');
        if (!cartLink) return;

        let bubble = cartLink.querySelector('.cart-count-bubble');
        if (cart.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            cartLink.appendChild(bubble);
          }
          bubble.innerHTML = `
            <span aria-hidden="true">${cart.item_count}</span>
            <span class="visually-hidden">Cart (${cart.item_count} items)</span>
          `;
        } else {
          if (bubble) bubble.remove();
        }
      })
      .catch(err => console.error('[CONFIGURATOR] Failed to update header cart count:', err));
  };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (window.showCartNotification) {
                window.showCartNotification("ITEM ADDED TO CART", "The product has been successfully added to your order slip.");
                if (window.updateHeaderCartCount) window.updateHeaderCartCount();
              } else {
                window.location = window.routes.cart_url;
              }
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
